<template>
  <modal name="contact-modal">
    <div slot="header">
      <p class="fs-medium m0">
        {{ $t('Zamów telefonicznie') }}
      </p>
    </div>
    <div class="row" slot="content">
      <div class="center-xs col-xs-12 col-sm-6">
        <i class="icon-phone cl-alternative" style="font-size: 44px;" />
        <p class="cl-alternative fs-medium">
          {{ $t('Zadzwoń do nas!') }}
        </p>
        <a href="tel:22-397-43-92" class="cl-alternative h3 weight-700 my15">
          22 397 43 92
        </a>
        <p class="h5 cl-matterhorn">
          {{ $t('Infolinia czynna') }}<br>
          {{ $t('pon - pt:') }} 10:00-18:00<br>
          {{ $t('sb:') }} 10:00-15:00
        </p>
      </div>
      <div class="center-xs col-xs-12 col-sm-6">
        <i class="icon-phone-order cl-alternative" style="font-size: 41px;" />
        <p class="cl-alternative fs-medium">
          {{ $t('Podaj nam swój numer') }}
        </p>
        <contact-input-phone
          class="col-xs-12 col-md-12 mb25 fs-sm-14"
          type="tel"
          name="phone-number"
          :placeholder="$t('Phone Number') + ' *'"
          @blur="$v.phoneNumber.$touch()"
          :autofocus="true"
          v-model.trim="phoneNumber"
          autocomplete="fakeautocomplete"
          :invalid="$v.$invalid"
          :validations="[
            {
              condition: $v.phoneNumber.$error && !$v.phoneNumber.required,
              text: $t('Field is required')
            },
            {
              condition: !$v.phoneNumber.phoneValidation && phoneNumber.length !== 0,
              text: $t('Wprowadzony numer telefonu jest nieprawidłowy!')
            }
          ]"
          :validate-phone="validatePhone"
          :update-phone="updatePhone"
        />
        <p class="h5 cl-matterhorn">
          {{ $t('Oddzwonimy w ciągu 2 godzin') }}<br>
          {{ $t('pon - pt:') }} 10:00-18:00<br>
          {{ $t('sb:') }} 10:00-15:00
        </p>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from 'theme/components/core/Modal';
import ContactInputPhone from 'theme/components/core/blocks/Form/ContactInputPhone';
import { required } from 'vuelidate/lib/validators';

function phoneValidation () {
  return this.phoneValidation === true;
}

export default {
  name: 'ContactModal',
  components: {
    Modal,
    ContactInputPhone
  },
  data () {
    return {
      phoneNumber: '',
      phoneValidation: false
    }
  },
  methods: {
    validatePhone (result) {
      this.phoneValidation = result.isValid;
    },
    updatePhone (phone) {
      this.phoneNumber = phone.number.national;
    }
  },
  validations: {
    phoneNumber: {
      required,
      phoneValidation
    }
  }
}
</script>
